/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const GetCandidatesSortPropertyDto = {
    QuizPoints: 'QUIZ_POINTS',
    StatusUpdatedAt: 'STATUS_UPDATED_AT',
    QuizFinishedAt: 'QUIZ_FINISHED_AT',
    AdminActionPossibleBefore: 'ADMIN_ACTION_POSSIBLE_BEFORE',
    Status: 'STATUS',
    SourceApp: 'SOURCE_APP',
    Candidate: 'CANDIDATE'
} as const;

export type GetCandidatesSortPropertyDto = typeof GetCandidatesSortPropertyDto[keyof typeof GetCandidatesSortPropertyDto];



